import { PreRegisForm } from "pages/RegistrationForm/RegistrationFormDecorator";
import * as yup from "yup";

type props = {
  formFieldsConfig: FormFieldConfig<PreRegisForm>;
};

const FormBuilder: React.FC<props> = ({ formFieldsConfig }) => {
  return <div>{}</div>;
};

export type FormFieldConfig<T> = {
  [K in keyof T]: {
    fieldName: K;
    label: string;
    validationType?: "default" | "engChrOnly" | "numberOnly" | "email";
    isRequired?: boolean;
  };
};

export const createYupSchema = (
  formFieldsConfig: FormFieldConfig<PreRegisForm>
) => {
  const schema: { [key: string]: any } = {};

  for (const field in formFieldsConfig) {
    const fieldConfig =
      formFieldsConfig[field as keyof typeof formFieldsConfig];

    if (fieldConfig) {
      const { validationType, isRequired } = fieldConfig;
      let validator: yup.StringSchema | yup.NumberSchema;

      // Apply additional validation based on 'validationType'
      switch (validationType) {
        case "engChrOnly":
          validator = yup
            .string()
            .matches(
              /^[a-zA-Z ]+$/,
              "Make sure you fill in your details in English only."
            );
          break;
        case "numberOnly":
          validator = yup.number().typeError("Must be a number.");
          break;
        case "email":
          validator = yup.string().email("E-mail format is not correct.");
          break;
        default:
          validator = yup.string();
          break;
      }

      // Apply the "required" validation if isRequired is true
      if (isRequired) {
        validator = validator.required("This field is required.");
      }

      // Adding the final validator to schema
      schema[field] = validator;
    }
  }

  return yup.object().shape(schema);
};

export default FormBuilder;
